/* URSO - Pagina de produto: variantes, galeria, zoom e barra fixa.
   Inicializa automaticamente todas as secoes .urso-pmain[data-sid]. */
(function () {
  'use strict';

  function money(c) {
    return 'R$ ' + (c / 100).toFixed(2).replace('.', ',');
  }

  function initSection(root) {
    if (!root || root.dataset.init === '1') return;
    root.dataset.init = '1';

    var sid = root.dataset.sid;
    var island = document.getElementById('upm-data-' + sid);
    if (!island) return;

    var data;
    try {
      data = JSON.parse(island.textContent);
    } catch (err) {
      return;
    }

    var $ = function (id) { return document.getElementById(id + '-' + sid); };
    var mainImg = $('upm-main');
    var current = null;

    /* ---------------- variantes ---------------- */
    function chosenMap() {
      var chosen = {};
      root.querySelectorAll('.urso-pmain__pills').forEach(function (g) {
        var act = g.querySelector('.urso-pmain__pill.is-active');
        if (act) chosen[Number(g.dataset.optPos) - 1] = act.dataset.value;
      });
      return chosen;
    }

    function syncStickyPills() {
      var wrap = $('upm-spills');
      if (!wrap) return;
      var g = root.querySelector('.urso-pmain__pills[data-opt-pos="1"]');
      var act = g ? g.querySelector('.urso-pmain__pill.is-active') : null;
      var val = act ? act.dataset.value : '';
      wrap.querySelectorAll('.urso-pmain__spill').forEach(function (p) {
        p.classList.toggle('is-active', p.dataset.value === val);
      });
    }

    function resolve(fire) {
      var chosen = chosenMap();
      var found = null;
      data.variants.forEach(function (v) {
        var ok = true;
        for (var k in chosen) { if (v.opts[k] !== chosen[k]) ok = false; }
        if (ok && !found) found = v;
      });
      current = found || data.variants[0];
      if (!current) return;

      var priceEl = $('upm-price');
      if (priceEl) priceEl.textContent = money(current.price);

      var capEl = $('upm-cap');
      var tagEl = $('upm-tag');
      if (current.cap > current.price) {
        if (capEl) { capEl.textContent = money(current.cap); capEl.classList.remove('is-hidden'); }
        if (tagEl) {
          tagEl.textContent = '-' + Math.round((current.cap - current.price) * 100 / current.cap) + '%';
          tagEl.classList.remove('is-hidden');
        }
      } else {
        if (capEl) capEl.classList.add('is-hidden');
        if (tagEl) tagEl.classList.add('is-hidden');
      }

      var pixEl = $('upm-pix');
      if (pixEl) {
        var parts = [];
        if (data.pix > 0) {
          parts.push('<b>' + money(Math.round(current.price * (100 - data.pix) / 100)) +
            '</b> a vista no Pix (' + data.pix + '% OFF)');
        }
        var parcMax = parseInt(data.parcMax, 10) || 1;
        var parcMin = parseInt(data.parcMin, 10) || 0;
        var n = parcMin ? Math.floor(current.price / parcMin) : parcMax;
        if (n > parcMax) n = parcMax;
        if (n < 1) n = 1;
        if (n > 1) {
          parts.push(n + 'x de ' + money(Math.round(current.price / n)) + ' sem juros');
        }
        pixEl.innerHTML = parts.join(' - ');
        pixEl.style.display = parts.length ? '' : 'none';
      }

      if (current.img && mainImg) {
        mainImg.src = current.img;
        setThumbActiveBySrc(current.img);
      }

      var addBtn = $('upm-add');
      if (addBtn) {
        addBtn.disabled = !current.av;
        addBtn.style.display = current.av ? '' : 'none';
      }
      var aviseBtn = $('upm-avise');
      if (aviseBtn) aviseBtn.style.display = current.av ? 'none' : '';
      var esgEl = $('upm-esgotado');
      if (esgEl) esgEl.style.display = current.av ? 'none' : '';

      root.querySelectorAll('.urso-pmain__pills').forEach(function (g) {
        var act = g.querySelector('.urso-pmain__pill.is-active');
        var lab = root.querySelector('[data-optname="' + g.dataset.optPos + '"]');
        if (act && lab) lab.textContent = act.dataset.value;
      });

      var sPrice = $('upm-sprice');
      if (sPrice) sPrice.textContent = money(current.price);
      var sImg = $('upm-simg');
      if (sImg && current.img) sImg.src = current.img;
      var sAdd = $('upm-sadd');
      if (sAdd) sAdd.disabled = !current.av;
      syncStickyPills();

      if (fire) {
        var first = root.querySelector('.urso-pmain__pills[data-opt-pos="1"] .urso-pmain__pill.is-active');
        document.dispatchEvent(new CustomEvent('urso:kit:flavor', {
          detail: { handle: data.handle, flavor: first ? first.dataset.value : '', from: 'pmain' }
        }));
        document.dispatchEvent(new CustomEvent('urso:kit:variant', { detail: { variant: current } }));
      }
    }

    root.querySelectorAll('.urso-pmain__pills').forEach(function (g) {
      g.querySelectorAll('.urso-pmain__pill').forEach(function (p) {
        p.addEventListener('click', function () {
          g.querySelectorAll('.urso-pmain__pill').forEach(function (x) { x.classList.remove('is-active'); });
          p.classList.add('is-active');
          resolve(true);
        });
      });
    });

    document.addEventListener('urso:kit:flavor', function (e) {
      if (!e.detail || e.detail.from === 'pmain' || e.detail.handle !== data.handle) return;
      var g = root.querySelector('.urso-pmain__pills[data-opt-pos="1"]');
      if (!g) return;
      var target = null;
      g.querySelectorAll('.urso-pmain__pill').forEach(function (p) {
        if (p.dataset.value === e.detail.flavor) target = p;
      });
      if (target && !target.classList.contains('is-active')) {
        g.querySelectorAll('.urso-pmain__pill').forEach(function (x) { x.classList.remove('is-active'); });
        target.classList.add('is-active');
        resolve(false);
      }
    });

    /* ---------------- estrelas vindas do app de avaliacoes ---------------- */
    var ratingEl = $('upm-rating');
    if (ratingEl && ratingEl.dataset.source !== 'manual') {
      var starsWrap = ratingEl.querySelector('.urso-pmain__stars');
      var numEl = ratingEl.querySelector('.urso-pmain__rnum');
      var cntEl = ratingEl.querySelector('.urso-pmain__rcount');
      var emptyEl = ratingEl.querySelector('.urso-pmain__rempty');

      var applyRating = function (avg, n) { if (!(n > 0)) return; /* selo vazio do app nao apaga a nota impressa no servidor */
        var v = Math.max(0, Math.min(5, avg || 0));
        ratingEl.style.setProperty('--pmn-star-pct', (v * 20) + '%');
        ratingEl.classList.toggle('is-empty', n <= 0);
        if (starsWrap) starsWrap.setAttribute('aria-label', 'Nota ' + v.toFixed(1) + ' de 5');
        if (numEl) {
          numEl.textContent = v.toFixed(1).replace('.', ',');
          numEl.hidden = (n <= 0 || ratingEl.dataset.shownum !== 'true');
        }
        if (cntEl) {
          cntEl.textContent = n + ' ' + (ratingEl.dataset.label || '');
          cntEl.hidden = n <= 0;
        }
        if (emptyEl) emptyEl.hidden = n > 0;
      };

      var srcEl = $('upm-jdgm');
      if (srcEl) {
        var tries = 0;
        var poll = setInterval(function () {
          tries += 1;
          var badge = srcEl.querySelector('[data-average-rating]');
          if (badge) {
            clearInterval(poll);
            applyRating(parseFloat(badge.getAttribute('data-average-rating')),
                        parseInt(badge.getAttribute('data-number-of-reviews'), 10) || 0);
          } else if (tries > 80) {
            clearInterval(poll);
          }
        }, 250);
      }
    }

    /* ---------------- quantidade ---------------- */
    root.querySelectorAll('.urso-pmain__qbtn').forEach(function (b) {
      b.addEventListener('click', function () {
        var inp = $('upm-qty');
        if (!inp) return;
        var v = (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.q, 10);
        if (v < 1) v = 1;
        inp.value = v;
      });
    });

    /* ---------------- galeria ---------------- */
    var thumbs = [].slice.call(root.querySelectorAll('.urso-pmain__thumb'));

    function setThumbActiveBySrc(src) {
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t.dataset.full === src); });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        if (mainImg) mainImg.src = t.dataset.full;
      });
    });

    /* ---------------- lightbox com ampliacao ---------------- */
    var lb = $('upm-light');
    if (lb) {
      var stage = $('upm-lbstage');
      var lbImg = $('upm-lbimg');
      var levelEl = lb.querySelector('.is-level');
      var maxZoom = parseFloat(lb.dataset.max) || 3;
      var stepZoom = parseFloat(lb.dataset.step) || 0.5;
      var scale = 1, tx = 0, ty = 0;
      var dragging = false, sx = 0, sy = 0, stx = 0, sty = 0;
      var pointers = {}, pinchDist = 0, pinchScale = 1;

      function apply() {
        lbImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
        stage.classList.toggle('is-zoomed', scale > 1.01);
        if (levelEl) levelEl.textContent = Math.round(scale * 100) + '%';
      }

      function clampPan() {
        var r = lbImg.getBoundingClientRect();
        var maxX = Math.max(0, (r.width - window.innerWidth) / 2 + 40);
        var maxY = Math.max(0, (r.height - window.innerHeight) / 2 + 40);
        if (tx > maxX) tx = maxX;
        if (tx < -maxX) tx = -maxX;
        if (ty > maxY) ty = maxY;
        if (ty < -maxY) ty = -maxY;
      }

      function setScale(next, ox, oy) {
        var prev = scale;
        scale = Math.min(maxZoom, Math.max(1, next));
        if (scale === 1) { tx = 0; ty = 0; }
        else if (typeof ox === 'number') {
          var f = scale / prev;
          tx = ox - (ox - tx) * f;
          ty = oy - (oy - ty) * f;
        }
        clampPan();
        apply();
      }

      function openLb(src) {
        lbImg.src = src;
        scale = 1; tx = 0; ty = 0;
        apply();
        lb.hidden = false;
        document.documentElement.style.overflow = 'hidden';
      }

      function closeLb() {
        lb.hidden = true;
        document.documentElement.style.overflow = '';
      }

      var zoomBtn = $('upm-zoom');
      if (zoomBtn) zoomBtn.addEventListener('click', function () { openLb(mainImg.src); });
      if (mainImg && root.querySelector('.urso-pmain__imgbox.is-zoomable')) {
        mainImg.addEventListener('click', function () { openLb(mainImg.src); });
      }

      lb.querySelectorAll('.urso-pmain__lb-tools button').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          var z = b.dataset.z;
          if (z === 'in') setScale(scale + stepZoom);
          else if (z === 'out') setScale(scale - stepZoom);
          else setScale(1);
        });
      });

      var closeBtn = lb.querySelector('.urso-pmain__lb-close');
      if (closeBtn) closeBtn.addEventListener('click', closeLb);

      function step(dir) {
        if (!thumbs.length) return;
        var idx = -1;
        thumbs.forEach(function (t, i) { if (t.dataset.full === lbImg.src) idx = i; });
        if (idx < 0) idx = 0;
        idx = (idx + dir + thumbs.length) % thumbs.length;
        openLb(thumbs[idx].dataset.full);
        if (mainImg) mainImg.src = thumbs[idx].dataset.full;
        setThumbActiveBySrc(thumbs[idx].dataset.full);
      }

      lb.querySelectorAll('.urso-pmain__lb-nav').forEach(function (b) {
        b.addEventListener('click', function (ev) {
          ev.stopPropagation();
          step(b.dataset.dir === 'next' ? 1 : -1);
        });
      });

      stage.addEventListener('wheel', function (ev) {
        ev.preventDefault();
        var rect = stage.getBoundingClientRect();
        var ox = ev.clientX - rect.left - rect.width / 2;
        var oy = ev.clientY - rect.top - rect.height / 2;
        setScale(scale + (ev.deltaY < 0 ? stepZoom : -stepZoom), ox, oy);
      }, { passive: false });

      stage.addEventListener('dblclick', function (ev) {
        var rect = stage.getBoundingClientRect();
        var ox = ev.clientX - rect.left - rect.width / 2;
        var oy = ev.clientY - rect.top - rect.height / 2;
        setScale(scale > 1.01 ? 1 : Math.min(maxZoom, 2), ox, oy);
      });

      stage.addEventListener('pointerdown', function (ev) {
        pointers[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
        var ids = Object.keys(pointers);
        if (ids.length === 2) {
          var a = pointers[ids[0]], b = pointers[ids[1]];
          pinchDist = Math.hypot(a.x - b.x, a.y - b.y);
          pinchScale = scale;
          dragging = false;
          return;
        }
        if (scale > 1.01) {
          dragging = true;
          sx = ev.clientX; sy = ev.clientY; stx = tx; sty = ty;
          stage.classList.add('is-panning');
          stage.setPointerCapture(ev.pointerId);
        }
      });

      stage.addEventListener('pointermove', function (ev) {
        if (pointers[ev.pointerId]) { pointers[ev.pointerId].x = ev.clientX; pointers[ev.pointerId].y = ev.clientY; }
        var ids = Object.keys(pointers);
        if (ids.length === 2 && pinchDist > 0) {
          var a = pointers[ids[0]], b = pointers[ids[1]];
          var d = Math.hypot(a.x - b.x, a.y - b.y);
          setScale(pinchScale * (d / pinchDist));
          return;
        }
        if (!dragging) return;
        tx = stx + (ev.clientX - sx);
        ty = sty + (ev.clientY - sy);
        clampPan();
        apply();
      });

      function endPointer(ev) {
        delete pointers[ev.pointerId];
        if (Object.keys(pointers).length < 2) pinchDist = 0;
        if (dragging) { dragging = false; stage.classList.remove('is-panning'); }
      }
      stage.addEventListener('pointerup', endPointer);
      stage.addEventListener('pointercancel', endPointer);

      stage.addEventListener('click', function (ev) {
        if (ev.target === stage && scale <= 1.01) closeLb();
      });

      document.addEventListener('keydown', function (ev) {
        if (lb.hidden) return;
        if (ev.key === 'Escape') closeLb();
        else if (ev.key === 'ArrowRight') step(1);
        else if (ev.key === 'ArrowLeft') step(-1);
        else if (ev.key === '+' || ev.key === '=') setScale(scale + stepZoom);
        else if (ev.key === '-') setScale(scale - stepZoom);
      });
    }

    /* ---------------- adicionar ao carrinho ---------------- */
    function addToCart(btn) {
      if (!current) return;
      var qtyEl = $('upm-qty');
      var qty = qtyEl ? (parseInt(qtyEl.value, 10) || 1) : 1;
      var item = { id: current.id, quantity: qty };
      var planSel = root.querySelector('input[name="upm-plan-' + sid + '"]:checked');
      if (planSel && planSel.value) item.selling_plan = planSel.value;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [item],
          sections: ['cart-drawer', 'cart-icon-bubble'],
          sections_url: window.location.pathname
        })
      }).then(function (r) { return r.json(); }).then(function (res) {
        btn.disabled = false;
        var d = document.querySelector('cart-drawer');
        if (res && res.sections && d && typeof d.renderContents === 'function') d.renderContents(res);
        if (typeof window.ursoOpenCart === 'function') window.ursoOpenCart();
        else if (d && typeof d.open === 'function') d.open();
      }).catch(function () { btn.disabled = false; });
    }

    var addMain = $('upm-add');
    if (addMain) addMain.addEventListener('click', function () { addToCart(addMain); });

    /* ---------------- barra fixa de variante ---------------- */
    var sticky = $('upm-sticky');
    if (sticky) {
      var spills = $('upm-spills');
      if (spills) {
        spills.querySelectorAll('.urso-pmain__spill').forEach(function (p) {
          p.addEventListener('click', function () {
            var g = root.querySelector('.urso-pmain__pills[data-opt-pos="1"]');
            if (!g) return;
            var target = null;
            g.querySelectorAll('.urso-pmain__pill').forEach(function (x) {
              if (x.dataset.value === p.dataset.value) target = x;
            });
            if (!target) return;
            g.querySelectorAll('.urso-pmain__pill').forEach(function (x) { x.classList.remove('is-active'); });
            target.classList.add('is-active');
            resolve(true);
          });
        });
      }
      var sAddBtn = $('upm-sadd');
      if (sAddBtn) sAddBtn.addEventListener('click', function () { addToCart(sAddBtn); });

      var anchor = root.querySelector('.urso-pmain__buybox') || root.querySelector('.urso-pmain__info');
      var showFrom = function () {
        var r = anchor.getBoundingClientRect();
        var past = r.bottom < 0;
        var footer = document.querySelector('.urso-footer, footer');
        var nearEnd = false;
        if (footer) {
          var fr = footer.getBoundingClientRect();
          nearEnd = fr.top < window.innerHeight - 40;
        }
        sticky.classList.toggle('is-visible', past && !nearEnd);
      };
      window.addEventListener('scroll', showFrom, { passive: true });
      window.addEventListener('resize', showFrom);
      showFrom();
    }

    /* ---------------- CEP ---------------- */
    var cepIn = $('upm-cep');
    if (cepIn) {
      var cepMsg = $('upm-cepmsg');
      var cepGo = function () {
        var zip = cepIn.value.replace(/[^0-9]/g, '');
        if (zip.length !== 8) { cepMsg.textContent = 'Digite um CEP valido, com 8 digitos.'; return; }
        cepMsg.textContent = 'Calculando...';
        fetch('/cart/shipping_rates.json?shipping_address%5Bzip%5D=' + zip + '&shipping_address%5Bcountry%5D=BR')
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var rates = j.shipping_rates;
            if (!rates || !rates.length) {
              cepMsg.textContent = 'Adicione o produto ao carrinho para calcular o frete deste CEP.';
              return;
            }
            var txt = [];
            rates.forEach(function (rt) { txt.push(rt.name + ': R$ ' + String(rt.price).replace('.', ',')); });
            cepMsg.textContent = txt.join(' - ');
          })
          .catch(function () {
            cepMsg.textContent = 'Adicione o produto ao carrinho para calcular o frete deste CEP.';
          });
      };
      var cepBtn = $('upm-cepbtn');
      if (cepBtn) cepBtn.addEventListener('click', cepGo);
      cepIn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); cepGo(); }
      });
    }

    resolve(false);
  }

  function boot() {
    document.querySelectorAll('.urso-pmain[data-sid]').forEach(initSection);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();